import {
	formatText,
	type DigitSpec,
	type NumericInput,
} from '@velocity-exchange/common/format';

/**
 * Abbreviates from 1000 up. `precision` (default 6) is a significant-figure
 * count, applied both above and below the threshold.
 */
export function millifyText(
	value: NumericInput,
	options?: {
		precision?: number;
		decimals?: number;
		notation?: 'scientific' | 'financial';
		trimEndingZeroes?: boolean;
	}
): string {
	const precision = options?.precision ?? 6;
	const trimEndingZeroes = options?.trimEndingZeroes ?? false;
	const significant: DigitSpec = {
		kind: 'significant',
		significant: precision,
		rounding: 'half-up',
	};

	return formatText(value, {
		digits: significant,
		grouping: false,
		trimTrailingZeros: trimEndingZeroes,
		abbreviate: {
			threshold: '1000',
			units: options?.notation === 'scientific' ? 'si' : 'financial',
			digits:
				options?.decimals === undefined
					? significant
					: {
							kind: 'decimals',
							decimals: options.decimals,
							rounding: 'half-up',
						},
			trimTrailingZeros: trimEndingZeroes,
		},
		fallback: '0',
		invalidText: '0',
	});
}
